/**
 * Largest single file the files router accepts.
 * The EPD dropzone uses the same limit so an oversized PDF is rejected before upload.
 */
export const MAX_FILES_UPLOAD_BYTES = 8_000_000;
